import Cookies from "js-cookie";
const BACKEND_PORT = process.env.REACT_APP_BACKEND_PORT || 5000;
const API_URL = process.env.REACT_APP_API_URL || "";

/**
 *
 * @param {string} path
 * @returns A localhost or production URL
 * @description The path to fetch (don't start path with "/")
 */
export const getApiUrl = (path = "") =>
  window.location.origin.includes("localhost")
    ? `http://localhost:${BACKEND_PORT}${path}`
    : `${API_URL}${path}`;

export const getAuthKey = () => Cookies.get("jwt");

/**
 * Checks if the current user session is valid and the user account is active
 * @returns {Promise<Object>} Object containing validity status and any error messages
 */
export const checkSessionValidity = async () => {
  try {
    const apiUrl = getApiUrl();
    const authKey = getAuthKey();

    // If no auth key exists, session is invalid
    if (!authKey) {
      return { valid: false, message: "No active session" };
    }

    // Send a request to verify the token and user status
    const response = await fetch(`${apiUrl}/session-check`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authKey}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();

      // Handle specific error cases
      if (response.status === 403) {
        if (errorData.message === "Administrator account has expired") {
          return {
            valid: false,
            message:
              "Your administrator account has expired. Please contact a super administrator.",
            expired: true,
          };
        } else if (errorData.message === "User account is disabled") {
          return {
            valid: false,
            message:
              "Your account has been disabled. Please contact an administrator.",
            disabled: true,
          };
        }
      }

      // For any other error, session is invalid
      Cookies.remove("jwt");
      return {
        valid: false,
        message: errorData.message || "Session is invalid",
      };
    }

    // Response was ok, session is valid
    return { valid: true };
  } catch (error) {
    console.error("Error checking session validity:", error);
    return { valid: false, message: "Error validating session" };
  }
};
